import { Card, CardContent, Typography, Box } from '@mui/material';
import styles from './header.module.scss';
import { CardProps, HeaderProps } from './types';
import { formattedRupee } from 'utils/util';

const DashboardCard = ({ title1, value1, title2, value2 }: CardProps) => (
  <Card className={styles.headerCard}>
    <CardContent>
      <Typography variant='h6'>{title1}</Typography>
      <Typography className={styles.headerCardSubTitle} variant='h4'>
        {value1}
      </Typography>
      <Typography variant='h6' gutterBottom sx={{ mt: 2 }}>
        {title2}
      </Typography>
      <Typography className={styles.headerCardSubTitle} variant='h4'>
        {value2}
      </Typography>
    </CardContent>
  </Card>
);

const DashboardHeader = ({ headerData }: HeaderProps) => {
  const data = [
    { title: 'Live Footfall Count', value: headerData.liveFootfallCount },
    { title: 'Live Demographics (M/F)', value: headerData.demographicCount },
    {
      title: 'Current Sales Value',
      value: `${formattedRupee(headerData.salesValue.toFixed(2))}`,
    },
    {
      title: 'Current Sales Margin',
      value: `${formattedRupee(headerData.salesMargin.toFixed(2))}`,
    },
    { title: 'SKU Available Count', value: headerData.skuCount },
    { title: 'SKU Out of Stock Count', value: headerData.outOfStockCount },
    {
      title: 'Average Order Value',
      value: `${formattedRupee(headerData.avgOrderValue.toFixed(2))}`,
    },
    { title: 'Item Count', value: headerData.itemCount },
  ];

  return (
    <Box className={styles.headerContainer}>
      {Array.from({ length: 4 }, (_, index) => (
        <DashboardCard
          key={index}
          title1={data[index * 2].title}
          value1={data[index * 2].value}
          title2={data[index * 2 + 1].title}
          value2={data[index * 2 + 1].value}
        />
      ))}
    </Box>
  );
};

export default DashboardHeader;
